/* eslint-disable jsx-a11y/anchor-has-content */
import cx from 'classnames';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutorizationModal from '../AutorizationModal';
import { capturePosthogEvent, posthogEvents } from '../../utils/posthog';
import { actionTypes } from '../../store/actions/menuModal';
import { environmentActions } from '../../store/actions';
import {
  getActiveExpert,
  getImageModalShow,
  getIsUserAuthenticated,
  getMenuModalShow,
  getSenderId,
  getIsEmex,
  getIsCurrentDialogArchive,
  getIsBigTabletAndDesktop,
  getPhoneNumber
} from '../../store/selectors';
import actions from '../../store/actions/meta';
import { useClickOutside } from '../../utils';
import { DEFAULT_TIME_TO_NEXT_CALL } from '../AutorizationModal/constants';
import { BasketIcon } from '../Icons';
import ExpertCard from '../ExpertCard';
import ExpertInfo from './ExpertInfo.js';
import Modal from '../Modal';
import SearchInput from '../SearchInput';
import ChangeExpertModal from '../ChangeExpertModal';
import LogoutPopup from '../LogoutPopup';
import { ReactComponent as SmartbeLogo } from '../../assets/icons/SmartbeLogo.svg';
import { ReactComponent as AccountIcon } from '../../assets/icons/AccountIcon.svg';
import {
  SEARCH_TABLET_BREAKPOINT,
  TABLET_BREAKPOINT,
  MOBILE_BREAKPOINT
} from '../../constants/breakpoints';
import s from './index.module.css';

const DESKTOP_SEARCH_PLACEHOLDER = 'Поиск по номеру детали';
const TABLET_SEARCH_PLACEHOLDER = 'Поиск';

const SMARTBE_CONNECT_TECH_LINK = 'https://smartbe.tilda.ws/?utm_source=emex&utm_medium=link&utm_campaign=logo/';
const SMARTBE_CART_LINK = 'https://smartbe.ru/cart/';

const Header = () => {
  const dispatch = useDispatch();
  const senderId = useSelector(getSenderId);
  const isAuthenticated = useSelector(getIsUserAuthenticated);
  const activeExpert = useSelector(getActiveExpert);
  const isEmex = useSelector(getIsEmex);
  const isShow = useSelector(getMenuModalShow);
  const isImageModalOpen = useSelector(getImageModalShow);
  const isArchiveDialog = useSelector(getIsCurrentDialogArchive);
  const isBigTabletAndDesktop = useSelector(getIsBigTabletAndDesktop);

  const initialPlaceholder = window.innerWidth > SEARCH_TABLET_BREAKPOINT ?
    DESKTOP_SEARCH_PLACEHOLDER : TABLET_SEARCH_PLACEHOLDER;

  const [showExpertCardModal, setShowExpertCard] = useState(false);
  const [isSmartbeLogoHovered, setSmartbeLogoHovered] = useState(false);
  const [isLogOutPopupOpened, setLogOutPopupOpened] = useState(false);
  const [changeExpertModalShow, setChangeExpertModalShow] = useState(false);
  const [isSearchActive, setSearchActive] = useState(false);

  const [timeToNextCall, setTimeToNextCall] = useState(DEFAULT_TIME_TO_NEXT_CALL);
  const [searchPlaceholder, setSearchPlaceholder] = useState(initialPlaceholder);
  const [searchQuery, setSearchQuery] = useState('');

  let searchWrapperRef = useRef(null);
  let loginButtonRef = useRef(null);

  const changeSearchPlaceholder = useCallback(() => {
    if (window.innerWidth > SEARCH_TABLET_BREAKPOINT && searchPlaceholder !== DESKTOP_SEARCH_PLACEHOLDER) {
      setSearchPlaceholder(DESKTOP_SEARCH_PLACEHOLDER);
    } else if (window.innerWidth <= SEARCH_TABLET_BREAKPOINT && searchPlaceholder !== TABLET_SEARCH_PLACEHOLDER) {
      setSearchPlaceholder(TABLET_SEARCH_PLACEHOLDER);
    }

    dispatch(environmentActions.setIsBigTabletAndDesktop(window.innerWidth >= TABLET_BREAKPOINT));
    dispatch(environmentActions.setIsMobile(window.innerWidth < MOBILE_BREAKPOINT));
  }, [setSearchPlaceholder, searchPlaceholder, isBigTabletAndDesktop]);

  useEffect(() => {
    window.addEventListener('resize', changeSearchPlaceholder);

    return () => {
      window.removeEventListener('resize', changeSearchPlaceholder);
    };
  }, [searchPlaceholder, setSearchPlaceholder, changeSearchPlaceholder]);

  const handleResetSearch = (e) => {
    if (e && e.target && e.target.blur) {
      e.target.blur();
    }

    setSearchActive(false);
    setSearchQuery('');
  };

  useClickOutside(searchWrapperRef, (e) => {
    handleResetSearch(e);
  });

  useClickOutside(loginButtonRef, (e) => {
    setLogOutPopupOpened(false);
  });

  const handleChangeSearch = (e) => {
    const query = (e && e.target && e.target.value) || '';
    setSearchQuery(query);
  };

  const handleFocusSearch = (e) => {
    setSearchActive(true);
  };

  const toggleMenu = () => {
    dispatch({ type: isShow ? actionTypes.CLOSE : actionTypes.OPEN });
  };

  const handleOpenAutorizationModal = (e) => {
    if (!isAuthenticated) {
      capturePosthogEvent(posthogEvents.AUTH_FORM_OPENED);
      dispatch(actions.toggleAuthModal(true));
      return;
    }

    setLogOutPopupOpened(!isLogOutPopupOpened);
  };

  const isPartreview = window.location.pathname.includes('/partreview');
  const isPartnerLogo = isEmex || isPartreview;

  const logoUrl = isPartreview ? 'https://partreview.ru' : 'https://emex.ru/';
  const isEmexHeader = isBigTabletAndDesktop && isEmex;
  const isSmartbeHeader = isBigTabletAndDesktop && !isEmex;

  const autorizationBlock = (
    <div className={s.userAccount}>
      <button
        ref={loginButtonRef}
        className={s.loginButton}
        disabled={senderId == null}
        onClick={handleOpenAutorizationModal}>
        <AccountIcon className={s.accountIcon} />
        {senderId && <span>{isAuthenticated ? 'Профиль' : 'Войти'}</span>}
      </button>
      {isLogOutPopupOpened && (
        <LogoutPopup
          isAuthenticated={isAuthenticated} />
      )}
    </div>
  );

  return (
    <header className={s.headerWrapper}>
      {isEmexHeader && <div className={s.emexHeader}>
        <AutorizationModal
          className={s.modal}
          timeToNextCall={timeToNextCall}
          setTimeToNextCall={setTimeToNextCall}
          showClose
          isPortal />
        <div className={s.headerContent}>
          <div className={s.leftSideContent}>
            <div className={s.logoColumn}>
              {isPartnerLogo && (
                <div className={s.emexLogoWrapper}>
                  <a
                    href={logoUrl}
                    className={cx({
                      [s.emexLogo]: isEmex,
                      [s.partReviewLogo]: isPartreview,
                    })}
                  ></a>
                  <a
                    className={cx(s.emexSmartbeLogoBox, {
                      [s.partReviewLabelLogoBox]: isPartreview,
                    })}
                    href={isEmex ? SMARTBE_CONNECT_TECH_LINK : '/Business'}
                    target="_blank"
                    rel="noopener noreferrer"
                    onMouseEnter={() => setSmartbeLogoHovered(true)}
                    onMouseLeave={() => setSmartbeLogoHovered(false)}
                  >
                    <div
                      className={cx(s.smartbeLabel, {
                        [s.smartbeLabelPartReview]: isPartreview,
                      })}
                    >
                      Работает на технологии
                    </div>
                    <div
                      className={cx(s.smartbeLabelPartReviewMobileHidden, {
                        [s.smartbeLabelPartReviewMobile]: isPartreview,
                      })}
                    >
                      Технология
                    </div>
                    <SmartbeLogo
                      className={cx({
                        [s.emexSmartbeLogo]: isPartnerLogo,
                        [s.emexSmartbeLogoHovered]: isSmartbeLogoHovered,
                        [s.partReviewSmartbeLogo]: isPartreview,
                      })}
                    />
                    <div
                      className={cx(s.smartbeLogoText, {
                        [s.partReviewSmartbeText]: isPartreview,
                      })}
                    >
                      смартби
                    </div>
                  </a>
                </div>
              )}
              {!isPartnerLogo && (
                <a
                  className={cx(s.navigation, s.logo, {
                    [s.smartbeLogo]: !isPartnerLogo,
                  })}
                  href="/"
                ></a>
              )}
            </div>
          </div>
          <div className={s.centerContent}>
            {!isArchiveDialog &&
              <div
                className={s.expertInfoContainerEmex}
                onMouseEnter={() => setShowExpertCard(true)}
                onMouseLeave={() => setShowExpertCard(false)}
              >
                <ExpertInfo isPartreview={isPartreview} />
                {showExpertCardModal && (
                  <Modal
                    className={s.expertModal}
                    showClose={false}
                    overlayClassName={s.expertModalOverlay}
                    isPortal={false}
                    withOverlay={false}
                  >
                    <ExpertCard className={s.expertCard} card={activeExpert} />
                  </Modal>
                )}
              </div>
            }
            <div className={s.emexRightContentWrapper}>
              {activeExpert && (
                <div>
                  <div className={s.mobileChangeExpert} onClick={() => setChangeExpertModalShow(true)}>
                    Позвать другого эксперта
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={s.rightSideContent}>
            {autorizationBlock}
          </div>
        </div>
      </div>}
      {isSmartbeHeader && <div className={cx(s.header, s.smartbeHeader)}>
        <AutorizationModal
          className={s.modal}
          timeToNextCall={timeToNextCall}
          setTimeToNextCall={setTimeToNextCall}
          showClose
          isPortal />
        <div className={s.emexHeader}>
          <div className={cx(s.leftSideContent, s.leftSideSmartbe)}>
            <a
              className={cx(s.navigation, s.logo, {
                [s.smartbeLogo]: !isPartnerLogo,
              })}
              href="/"
            ></a>
          </div>
          <div className={s.centerContent}>
            <div
              className={s.expertInfoContainerEmex}
              onMouseEnter={() => setShowExpertCard(true)}
              onMouseLeave={() => setShowExpertCard(false)}
            >
              <ExpertInfo isPartreview={isPartreview} />
              {showExpertCardModal && (
                <Modal
                  className={s.expertModal}
                  showClose={false}
                  overlayClassName={s.expertModalOverlay}
                  isPortal={false}
                  withOverlay={false}
                >
                  <ExpertCard className={s.expertCard} card={activeExpert} />
                </Modal>
              )}
            </div>
            <div className={s.searchWrapper} ref={searchWrapperRef}>
              <SearchInput
                searchQuery={searchQuery}
                isSearchActive={isSearchActive}
                searchPlaceholder={searchPlaceholder}
                onReset={handleResetSearch}
                onChange={handleChangeSearch}
                onFocus={handleFocusSearch}
              />
            </div>
          </div>
          <div className={s.rightSideContent}>
            {autorizationBlock}
            <a className={s.basketWrapper} href={SMARTBE_CART_LINK}>
              <BasketIcon />
              <div className={s.basketText}>Корзина</div>
            </a>
          </div>
        </div>
      </div>}

      {changeExpertModalShow && <ChangeExpertModal onClose={() => setChangeExpertModalShow(false)} />}
    </header>
  );
};

export default Header;
